import { Typo } from "@pepperstone/pepper-ui-kit";

type PageHeadingProps = {
  header: string;
};

export const PageHeading = ({ header }: PageHeadingProps) => (
  <Typo
    elem="h1"
    size="md"
    type="display"
    textColor="ps-text-text-primary-base"
    responsiveClasses="lg:ps-text-display-xs"
  >
    {header}
  </Typo>
);
